import moment from 'moment-timezone';

const state ={
  // currentDate:moment().format('YYYY-MM-DD'),
  // startDate:moment().subtract(30, 'days').format('YYYY-MM-DD'),
  currentDate: moment,
  startDate: moment,
};

const getters ={
  getDates: (state) =>{
    return{
      current: state.currentDate,
      start: state.startDate,
   };
 }
};
export default{
  state,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/Date.store.js